var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddYourData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    zoomAndPan: "magnify",
    viewBox: "0 0 960 540.000001",
    height: 720,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "79302a9474"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.886719 0 L 959.113281 0 L 959.113281 539 L 0.886719 539 Z M 0.886719 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "034fd35231"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 259.742188 49.242188 L 699.925781 49.242188 L 699.925781 489.425781 L 259.742188 489.425781 Z M 259.742188 49.242188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79302a9474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.886719 0 L 959.113281 0 L 959.113281 539 L 0.886719 539 Z M 0.886719 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.886719 0 L 959.113281 0 L 959.113281 539 L 0.886719 539 Z M 0.886719 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#034fd35231)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#174461",
    d: "M 479.996094 49.242188 C 358.5 49.242188 259.742188 148 259.742188 269.496094 C 259.742188 390.992188 358.5 489.753906 479.996094 489.753906 C 601.492188 489.753906 700.253906 390.992188 700.253906 269.496094 C 700.253906 148 601.492188 49.242188 479.996094 49.242188 Z M 603.765625 290.8125 L 501.3125 290.8125 L 501.3125 393.265625 C 501.3125 404.917969 491.792969 414.582031 479.996094 414.582031 C 468.203125 414.582031 458.679688 404.917969 458.679688 393.265625 L 458.679688 290.8125 L 356.226562 290.8125 C 344.574219 290.8125 334.910156 281.292969 334.910156 269.496094 C 334.910156 257.703125 344.574219 248.183594 356.226562 248.183594 L 458.679688 248.183594 L 458.679688 145.726562 C 458.679688 134.074219 468.203125 124.414062 479.996094 124.414062 C 491.792969 124.414062 501.3125 134.074219 501.3125 145.726562 L 501.3125 248.183594 L 603.765625 248.183594 C 615.417969 248.183594 625.082031 257.703125 625.082031 269.496094 C 625.082031 281.292969 615.417969 290.8125 603.765625 290.8125 Z M 603.765625 290.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddYourData);
export default __webpack_public_path__ + "static/media/addYourData.b5f2121305ee7f7ad382f955e5b587c1.svg";
export { ForwardRef as ReactComponent };